import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"
import { currentUrl } from "../../../url"

export const operationsApi = createApi({
  reducerPath: "operationsApi",
  tagTypes: ["Transaction", "Transfer"],
  refetchOnMountOrArgChange: true,
  baseQuery: fetchBaseQuery({
    baseUrl: currentUrl,
    prepareHeaders: (headers) => {
      const accessToken = localStorage.getItem("accessToken")
      if (accessToken) {
        const token = accessToken.startsWith("Bearer ")
          ? accessToken
          : `Bearer ${accessToken}`
        headers.set("Authorization", token)
        headers.set("Accept", "application/json")
        headers.set("Content-Type", "application/json")
      }
      return headers
    },
  }),
  endpoints: (build) => ({
    // ── TRANSACTIONS (income / expense) ──────────────────────────────

    // GET /finance/transactions
    getTransactions: build.query({
   
      query: (params = {}) => {
  const { type, account_id, transaction_category_id, client_id, employee_id, counterparty_id, date_from, date_to, page = 1, per_page = 10 } = params
  const qs = new URLSearchParams()
  if (type) qs.set("type", type)
  if (account_id) qs.set("account_id", account_id)
  if (transaction_category_id) qs.set("transaction_category_id", transaction_category_id)
  if (client_id) {
    qs.set("client_id", client_id)
    qs.set("salon_client_id", client_id)
  }
  if (employee_id) {
    qs.set("employee_id", employee_id)
    qs.set("master_id", employee_id)
  }
  if (counterparty_id) qs.set("counterparty_id", counterparty_id)
  if (date_from) qs.set("date_from", date_from)
  if (date_to) qs.set("date_to", date_to)
  qs.set("page", page)
  qs.set("per_page", per_page) // ← добавь
  return `/master/finance/transactions?${qs.toString()}`
},
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ id }) => ({ type: "Transaction", id })),
              { type: "Transaction", id: "LIST" },
            ]
          : [{ type: "Transaction", id: "LIST" }],
    }),

    // GET /finance/transactions/{id}
    getTransaction: build.query({
      query: (id) => `/master/finance/transactions/${id}`,
      providesTags: (result, error, id) => [{ type: "Transaction", id }],
    }),

    // POST /finance/transactions
    createTransaction: build.mutation({
      query: (body) => ({
        url: `/master/finance/transactions`,
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "Transaction", id: "LIST" }],
    }),

    // PATCH /finance/transactions/{id}
    updateTransaction: build.mutation({
      query: ({ id, ...body }) => ({
        url: `/master/finance/transactions/${id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "Transaction", id: "LIST" },
        { type: "Transaction", id },
      ],
    }),

    // DELETE /finance/transactions/{id}
    deleteTransaction: build.mutation({
      query: (id) => ({
        url: `/master/finance/transactions/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, id) => [
        { type: "Transaction", id: "LIST" },
        { type: "Transaction", id },
      ],
    }),

    // ── TRANSFERS ─────────────────────────────────────────────────────

    // GET /finance/transfers
   getTransfers: build.query({
  query: (params = {}) => {
    const { account_id, date_from, date_to, page = 1, per_page = 10 } = params
    const qs = new URLSearchParams()
    if (account_id) qs.set("account_id", account_id)
    if (date_from) qs.set("date_from", date_from)
    if (date_to) qs.set("date_to", date_to)
    qs.set("page", page)
    qs.set("per_page", per_page)
    return `/master/finance/transfers?${qs.toString()}`
  },
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ id }) => ({ type: "Transfer", id })),
              { type: "Transfer", id: "LIST" },
            ]
          : [{ type: "Transfer", id: "LIST" }],
    }),

    // GET /finance/transfers/{id}
    getTransfer: build.query({
      query: (id) => `/master/finance/transfers/${id}`,
      providesTags: (result, error, id) => [{ type: "Transfer", id }],
    }),

    // POST /finance/transfers
    createTransfer: build.mutation({
      query: (body) => ({
        url: `/master/finance/transfers`,
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "Transfer", id: "LIST" }],
    }),

    // PATCH /finance/transfers/{id}
    updateTransfer: build.mutation({
      query: ({ id, ...body }) => ({
        url: `/master/finance/transfers/${id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "Transfer", id: "LIST" },
        { type: "Transfer", id },
      ],
    }),

    // DELETE /finance/transfers/{id}
    deleteTransfer: build.mutation({
      query: (id) => ({
        url: `/master/finance/transfers/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, id) => [
        { type: "Transfer", id: "LIST" },
        { type: "Transfer", id },
      ],
    }),
  }),
})

export const {
  useGetTransactionsQuery,
  useGetTransactionQuery,
  useCreateTransactionMutation,
  useUpdateTransactionMutation,
  useDeleteTransactionMutation,
  useGetTransfersQuery,
  useGetTransferQuery,
  useCreateTransferMutation,
  useUpdateTransferMutation,
  useDeleteTransferMutation,
} = operationsApi
